export default "__VITE_ASSET__7e7bb078__"